import fetch from 'utils/fetch'

// 成人-上一次接种的门诊
export function fetchAdultOffice(params, other) {
  return fetch({
    url: '/master/maPov/vacc/pov/adult',
    params,
    ...other
  })
}

// 儿童-档案归属地门诊
export function fetchChildOffice(params, other) {
  return fetch({
    url: '/master/maPov/vacc/pov/children',
    params,
    ...other
  })
}

// 门诊列表
export function fetchOffice(params) {
  return fetch({
    url: '/master/maPov/appPage',
    params
  })
}